import { CULTURES_COUNTRY } from '@openflex/component'
import getCultureCountry from 'core/utils/cultures/country'
import * as defaultFields from './default'
import * as noFields from './no'

export const getFormFields = type => {
  switch (getCultureCountry()) {
    default:
      return Object.keys(defaultFields.default.formFields).includes(type)
        ? defaultFields.default.formFields[type]
        : []
    case CULTURES_COUNTRY.NO:
    case CULTURES_COUNTRY.SE:
    case CULTURES_COUNTRY.FI:
      return Object.keys(noFields.default.formFields).includes(type)
        ? noFields.default.formFields[type]
        : []
  }
}

export const getRequiredFields = vehicle => {
  const base = [vehicle.tiresStateFront, vehicle.tiresStateBack]
  switch (getCultureCountry()) {
    default:
      return base
    case CULTURES_COUNTRY.NO:
    case CULTURES_COUNTRY.SE:
    case CULTURES_COUNTRY.FI:
      return vehicle.secondTyres
        ? [
            ...base,
            vehicle.secondTyres,
            vehicle.tyresType,
            vehicle.secondTiresStateFront,
            vehicle.secondTiresStateBack
          ]
        : [...base, vehicle.secondTyres, vehicle.tyresType]
  }
}
